function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareLocaleKeys from '../../../../../locales/keys';
import { clone, path } from 'ramda';
import { REGEXES } from '../../../../../customercare.constants';

/*
    NOTE: This is a "dumb" component. Most logic can be found in order.details.component.js
*/
var ResendGiftNotificationModal = /*#__PURE__*/function () {
  function ResendGiftNotificationModal() {
    _classCallCheck(this, ResendGiftNotificationModal);
    this.localeKeys = CustomerCareLocaleKeys;
    this.currentDate = new Date();
    this.emailPattern = REGEXES.EMAIL;
    this.viewModel = {
      giftOrderInfo: {
        giftMessage: null,
        orderId: null,
        recipientEmail: null,
        recipientName: null
      },
      errors: [],
      isSubmitting: false
    };
  }
  return _createClass(ResendGiftNotificationModal, [{
    key: "$onChanges",
    value: function $onChanges(changes) {
      if (changes.giftOrderInfo) {
        this.viewModel.giftOrderInfo = clone(changes.giftOrderInfo.currentValue);
      }
      if (changes.lastAttemptError) {
        this.viewModel.errors = this._getLastAttemptErrorArray(changes.lastAttemptError.currentValue);
      }
      if (changes.isSubmitting) {
        this.viewModel.isSubmitting = changes.isSubmitting.currentValue;
      }
    }
  }, {
    key: "_getLastAttemptErrorArray",
    value: function _getLastAttemptErrorArray(lastAttemptError) {
      var errorMessage = path(['message'], lastAttemptError);
      return errorMessage ? [errorMessage] : [];
    }
  }, {
    key: "edit",
    value: function edit() {
      var onEdit = this.onEdit;
      onEdit && onEdit()(this.viewModel.giftOrderInfo);
    }
  }, {
    key: "submit",
    value: function submit() {
      if (this.giftOrderInfoForm.$valid) {
        this.giftOrderInfoForm.$setPristine();
        var onSubmit = this.onSubmit;
        onSubmit && onSubmit()(this.viewModel.giftOrderInfo);
      }
    }
  }, {
    key: "close",
    value: function close() {
      this.giftOrderInfoForm.$setPristine();
      var onClose = this.onClose;
      onClose && onClose()();
    }
  }]);
}();
export default {
  controller: ResendGiftNotificationModal,
  template: require('./resend.gift.notification.modal.html'),
  bindings: {
    onClose: '&',
    onSubmit: '&',
    onEdit: '&',
    isSubmitting: '<',
    giftOrderInfo: '<',
    lastAttemptError: '<'
  }
};